/* eslint-disable no-unreachable */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Highlight, connectAutoComplete } from 'react-instantsearch-dom';
import AutoSuggest from 'react-autosuggest';
import { withTranslation } from 'react-i18next';

class AutoComplete extends Component {
  static propTypes = {
    hits: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentRefinement: PropTypes.string.isRequired,
    refine: PropTypes.func.isRequired,
    onSuggestionSelected: PropTypes.func.isRequired,
    onSuggestionCleared: PropTypes.func.isRequired,
  };

  state = {
    value: this.props.currentRefinement,
  };

  onChange = (_, { newValue }) => {
    if (!newValue) {
      this.props.onSuggestionCleared();
    }

    this.setState({
      value: newValue,
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    if (value.length === 1) {
      this.props.refine(value);
      return true;
    }

    if (value.length > 1 && value.length < 5) {
      return true;
    }

    window.clearTimeout(this.timerId);
    this.timerId = window.setTimeout(() => this.props.refine(value), 500);
  };

  onSuggestionsClearRequested = () => {
    this.props.refine();
  };

  getSuggestionValue(hit) {
    return hit.post_title;
  }

  renderSuggestion(hit) {
    return <Highlight attribute="post_title" hit={hit} />;
  }

  shouldRenderSuggestions(value) {
    return value.length >= 1;
  }

  render() {
    const { hits, onSuggestionSelected, t } = this.props;
    const { value } = this.state;

    const inputProps = {
      placeholder: t('Digita il nome della prestazione richiesta'),
      onChange: this.onChange,
      value,
    };

    return (
      <AutoSuggest
        suggestions={hits}
        shouldRenderSuggestions={this.shouldRenderSuggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}

export default withTranslation()(connectAutoComplete(AutoComplete));